import { render, staticRenderFns } from "./WakeComponent.vue?vue&type=template&id=29673816&scoped=true&"
import script from "./WakeComponent.vue?vue&type=script&lang=js&"
export * from "./WakeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29673816",
  null
  
)

export default component.exports